export default {
  API_BASE_URL: 'https://atc-api.dev.' + window.BRAND_API_DOMAIN  + '/v1/',
  IMAGE_BASE_URL: 'https://atc-api.dev.' + window.BRAND_API_DOMAIN + '/v1/',
  VERSION: '5097d91',
  GA_ID: 'UA-6070396-7',
  ENVIRONMENT: 'development',
  SENTRY_TRACE_RATE: 1.0
};
